export function hasValues <T>(target: any, ...omitKeys: (keyof T)[]) {
  if (!target) return false;
  return (Object.keys(target) as (keyof T)[])
    .filter((key) => !omitKeys.includes(key))
    .every((key) => target[key]);
}
